import $ from "jquery";
import Toastify from "toastify-js";

$(function () {
    if ($(".woocommerce .product-image-slider").length) {
        const galleryThumbs = new window.Swiper(".woocommerce .product-thumbnail-slider", {
            slidesPerView: 3,
            spaceBetween: "16",
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 5,
                },
                1280: {
                    slidesPerView: 6,
                },
            },
        });

        if ($(".woocommerce .product-thumbnail-slider").length) {
            const galleryTop = new window.Swiper(".woocommerce .product-image-slider", {
                loop: true,
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            });
        }
    }
});

$(document).on("change input", ".woocommerce-cart-form .cart_item :input", function (e) {
    $('.woocommerce-cart-form :input[name="update_cart"]').prop("disabled", false);
});

$(document).on("click", ".plus", function (e) {
    const $input = $(this).siblings("input.qty");
    console.log($input);
    const $inputName = $input.attr("name");
    const $inputID = $input.attr("id");
    // Search for second input with the same name to work around correctly updating the cart.
    const $secondInput = $(`.woocommerce-cart input[name='${$inputName}']:not([id='${$inputID}'])`);
    const max = parseInt($input.attr("max"));
    const val = parseInt($input.val());
    let step = $input.attr("step");
    step = "undefined" !== typeof step ? parseInt(step) : 1;
    if (isNaN(max) || val < max) {
        $input.val(val + step).change();
        if ($secondInput.length !== 0) {
            $secondInput.val(val + step).change();
        }
    }
});
$(document).on("click", ".minus", function (e) {
    const $input = $(this).siblings("input.qty");
    const $inputName = $input.attr("name");
    const $inputID = $input.attr("id");
    // Search for second input with the same name to work around correctly updating the cart.
    const $secondInput = $(`.woocommerce-cart input[name='${$inputName}']:not([id='${$inputID}'])`);
    const val = parseInt($input.val());
    let step = $input.attr("step");
    step = "undefined" !== typeof step ? parseInt(step) : 1;
    if (val > 0) {
        $input.val(val - step).change();
        if ($secondInput.length !== 0) {
            $secondInput.val(val - step).change();
        }
    }
});

if (typeof frameworkData !== "undefined") {
    const ToastifyNotices = {
        init() {
            frameworkData.show_in_toast?.forEach((type) => {
                switch (type) {
                    case "success":
                        ToastifyNotices.onElementInserted(
                            "body",
                            ".woocommerce-message",
                            "",
                            ToastifyNotices.createToast,
                        );
                        ToastifyNotices.checkExistingElements(".woocommerce-message");
                        break;
                    case "error":
                        ToastifyNotices.onElementInserted(
                            "body",
                            ".woocommerce-error",
                            "li",
                            ToastifyNotices.createToast,
                        );
                        ToastifyNotices.checkExistingElements(".woocommerce-error li");
                        break;
                    case "info":
                        ToastifyNotices.onElementInserted("body", ".woocommerce-info", "", ToastifyNotices.createToast);
                        ToastifyNotices.checkExistingElements(".woocommerce-info");
                        break;
                    default:
                        break;
                }
            });
        },
        onElementInserted(containerSelector, selector, childSelector, callback) {
            if ("MutationObserver" in window) {
                const onMutationsObserved = (mutations) => {
                    mutations.forEach(({ addedNodes }) => {
                        if (addedNodes.length) {
                            if (jQuery(addedNodes).length) {
                                let finalSelector = selector;
                                let ownElement = jQuery(addedNodes).filter(selector);
                                if (childSelector != "") {
                                    ownElement = ownElement.find(childSelector);
                                    finalSelector = `${selector} ${childSelector}`;
                                }
                                ownElement.each(function (index) {
                                    callback(jQuery(this), index + 1, ownElement.length, finalSelector, true);
                                });
                                if (!ownElement.length) {
                                    const childElements = jQuery(addedNodes).find(finalSelector);
                                    childElements.each(function (index) {
                                        callback(jQuery(this), index + 1, childElements.length, finalSelector, true);
                                    });
                                }
                            }
                        }
                    });
                };

                const target = jQuery(containerSelector)[0];
                const config = { childList: true, subtree: true };
                const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
                const observer = new MutationObserver(onMutationsObserved);
                observer.observe(target, config);
            } else {
                console.log("No MutationObserver");
            }
        },
        checkExistingElements(selector) {
            const element = jQuery(selector);
            if (element.length) {
                element.each(function (index) {
                    ToastifyNotices.createToast(jQuery(this), index + 1, element.length, selector, false);
                });
            }
        },
        createToast(element, index, total, selector, dynamic) {
            let noticeType = "success";
            let noticeIcon = "fas:check-circle";

            if (selector.includes("error")) {
                noticeType = "error";
                noticeIcon = "fas:times-circle";
            } else if (selector.includes("info")) {
                noticeType = "info";
                noticeIcon = "fas:info-circle";
            }

            const message = element.html().trim();
            const html = `<div class="toast-inner"><iconify-icon class="iconify" icon="${noticeIcon}"></iconify-icon>${message}</div>`;

            requestAnimationFrame(() => {
                const toast = Toastify({
                    text: html,
                    escapeMarkup: false,
                    duration: 10000,
                    className: noticeType,
                    close: true, // Show a close button so the notice can be dismissed
                    gravity: Foundation.MediaQuery.atLeast("sm") ? "top" : "bottom", // `top` or `bottom`
                    position: Foundation.MediaQuery.atLeast("sm") ? "right" : "center", // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    onClick: function () {
                        toast.hideToast();
                    }, // Callback after click
                });

                toast.showToast();
            });
        },
    };
    ToastifyNotices.init();
}
